module.exports = __webpack_public_path__ + "img/surat-add-penduduk-min.6dbda9ea.png";